import { Injectable } from '@angular/core';
import { HttpCall } from './httpcall.service';
import { UnsubscribeOnDestroyAdapter } from '../shared/UnsubscribeOnDestroyAdapter';
import { httpRoutes, httpVersion, superAdminRoutes } from 'src/consts/http-routes';
import { ProcessDocument } from 'src/consts/common.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { WEB_ROUTES } from 'src/consts/routes';
import { showNotification } from 'src/consts/utils';
import { configData } from 'src/environments/configData';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends UnsubscribeOnDestroyAdapter {


  constructor(private httpCall: HttpCall, private router: Router, private snackBar: MatSnackBar,) {
    super();
  }

  async saveAttachment(requestObject: any) {
    const data = await this.httpCall.httpPostCall(httpVersion.PORTAL_V1 + httpRoutes.PORTAL_SAVE_ATTACHMENT, requestObject).toPromise();
    if (data.status === false && data.message === configData.SESSION_EXPIRED) {
      showNotification(this.snackBar, data.message, 'error');
      localStorage.removeItem(localStorageConstants.USERDATA);
      localStorage.removeItem(localStorageConstants.COMPANYDATA);
      localStorage.removeItem(localStorageConstants.COMPANYID);
      localStorage.removeItem(localStorageConstants.INVOICE_GIF);
      localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
      localStorage.setItem(localStorageConstants.LOGOUT, 'true');
      this.router.navigate([WEB_ROUTES.LOGIN]);
      location.reload();
    } else {
      return data;
    }
  }

  async saveAttachmentForSuperadmin(requestObject: any) {
    const data = await this.httpCall.httpPostCall(httpVersion.SUPERADMIN_V1 + superAdminRoutes.SAVE_ATTACHMENT, requestObject).toPromise();
    if (data.status === false && data.message === configData.SESSION_EXPIRED) {
      showNotification(this.snackBar, data.message, 'error');
      localStorage.removeItem(localStorageConstants.USERDATA);
      localStorage.removeItem(localStorageConstants.COMPANYDATA);
      localStorage.removeItem(localStorageConstants.COMPANYID);
      localStorage.removeItem(localStorageConstants.INVOICE_GIF);
      localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
      localStorage.setItem(localStorageConstants.LOGOUT, 'true');
      this.router.navigate([WEB_ROUTES.LOGIN]);
      location.reload();
    } else {
      return data;
    }
  }

  async getRequestAPI(apiUrl: string) {
    const data = await this.httpCall.httpGetCall(apiUrl).toPromise();
    if (data.status === false && data.message === configData.SESSION_EXPIRED) {
      showNotification(this.snackBar, data.message, 'error');
      localStorage.removeItem(localStorageConstants.USERDATA);
      localStorage.removeItem(localStorageConstants.COMPANYDATA);
      localStorage.removeItem(localStorageConstants.COMPANYID);
      localStorage.removeItem(localStorageConstants.INVOICE_GIF);
      localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
      localStorage.setItem(localStorageConstants.LOGOUT, 'true');
      this.router.navigate([WEB_ROUTES.LOGIN]);
      location.reload();
    } else {
      return data;
    }
  }

  async postRequestAPI(apiUrl: string, requestObject: any) {
    const data = await this.httpCall.httpPostCall(apiUrl, requestObject).toPromise();
    if (data.status === false && data.message === configData.SESSION_EXPIRED) {
      showNotification(this.snackBar, data.message, 'error');
      localStorage.removeItem(localStorageConstants.USERDATA);
      localStorage.removeItem(localStorageConstants.COMPANYDATA);
      localStorage.removeItem(localStorageConstants.COMPANYID);
      localStorage.removeItem(localStorageConstants.INVOICE_GIF);
      localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
      localStorage.setItem(localStorageConstants.LOGOUT, 'true');
      this.router.navigate([WEB_ROUTES.LOGIN]);
      location.reload();
    } else {
      return data;
    }
  }

  isDuplicateDocumentTblLoading = true;
  duplicateDocumentDataChange: BehaviorSubject<ProcessDocument[]> = new BehaviorSubject<ProcessDocument[]>([]);
  get duplicateDocumentData(): ProcessDocument[] {
    return this.duplicateDocumentDataChange.value;
  }
  async getDuplicateDocumentTable(): Promise<void> {
    const data = await this.httpCall.httpGetCall(httpVersion.PORTAL_V1 + httpRoutes.GET_DUPLICATE_DOCUMENT_FOR_TABLE).toPromise();
    this.isDuplicateDocumentTblLoading = false;
    this.duplicateDocumentDataChange.next(data);
  }

  postRequestWithoutTokenAPI(apiUrl: string, requestObject: any) {
    return this.httpCall.httpPostCallWithoutToken(apiUrl, requestObject);
  }

  postRequestWithPaymentMethodIdAPI(apiUrl: string, requestObject: any, params: { paymentMethodId: any }): Observable<any> {
    // Pass `params` to the updated method
    return this.httpCall.httpPostCallWithoutTokenWidthParams(apiUrl, requestObject, params)
  }
}
